import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { HotelEntitiesResponse } from 'app/typings/core/admin/hotel/hotelEntities';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useGetHotelEntities(id?: string | number) {
  const hotelId = id?.toString();

  return useQuery({
    queryKey: [CORE_QUERY_KEYS.hotelEntities, { id: hotelId }],
    queryFn: hotelId
      ? () =>
          apiRequest({
            path: ENDPOINTS.getHotelEntities,
            params: { id: hotelId },
          }) as Promise<HotelEntitiesResponse>
      : () => Promise.resolve(undefined),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!hotelId,
  });
}
